module.exports = __webpack_public_path__ + "static/media/einvoice-refund-note.4566b9d7.svg";